import { gql } from '@apollo/client';

export const insertEraCareQuestionnaireResponseMutation = gql`
  mutation ($object: era_care_responses_insert_input!) {
    insert_era_care_responses_one(object: $object) {
      era_care_notification_id
    }
  }
`;
